import { Flex, Text } from "rebass/styled-components";
import { useRecoilValue } from "recoil";
import styled from "styled-components";

import { MatchHistoryMatchThumbnailState } from "MVVM/State/matchHistory";
import { TMoment } from "MVVM/Views/MatchHistory/@types";
import { MomentDetails } from "../../MomentDetails";
import { Button } from "MVVM/Components/Button";
import { analytics } from "MVVM/Analytics";
import { ESupportedGames } from "MVVM/@types";
import { useState } from "react";

export const ValorantComingSoonModal = ({
  moment,
  title,
  subtitle,
  closeModal,
}: {
  moment?: TMoment;
  title: string;
  subtitle: string;
  closeModal: () => void;
}) => {
  const matchThumbnail = useRecoilValue(MatchHistoryMatchThumbnailState);
  const [notified, setNotified] = useState(false);

  function notifyMeOnValorant() {
    try {
      setNotified(true);
      analytics.track("Valorant Notification", {});
      setTimeout(() => {
        closeModal();
      }, 2000);
    } catch (error) {
      console.error("Failed to track Valorant notification:", error);
      // Still close modal even if analytics fails
      setTimeout(() => {
        closeModal();
      }, 2000);
    }
  }

  return (
    <Container>
      <ChampionBanner
        style={{
          backgroundImage: `linear-gradient(to bottom, transparent, var(--Gray-750, #1c2a34)), url(${matchThumbnail})`,
        }}
      />
      {!!moment && (
        <MomentDetails
          moment={moment}
          matchHistoryGame={ESupportedGames.VALORANT}
        />
      )}
      <Flex
        style={{ padding: "12px 24px 24px", gap: "24px" }}
        flexDirection="column"
      >
        <Flex flexDirection="column" textAlign="center" style={{ gap: "12px" }}>
          <Title color="ice" variant="text.titleSmall">
            {title}
          </Title>
          <Subtitle color="chalk" variant="text.paragraphMedium">
            {subtitle}
          </Subtitle>
        </Flex>
        <StyledButton
          onClick={notifyMeOnValorant}
          disabled={notified}
          notified={notified}
        >
          {notified
            ? "Thanks, we'll email you when ready!"
            : "Notify Me When Ready"}
        </StyledButton>

        <StyledNoThanks onClick={() => closeModal()}>
          No, Thank You
        </StyledNoThanks>
      </Flex>
    </Container>
  );
};

const Container = styled(Flex)`
  position: relative;
  width: 448px;
  flex-direction: column;
  background-color: var(--Gray-750, #1c2a34);
  text-align: center;
  border-radius: 14px;
  border: ${({ theme }) => `1px solid ${theme.colors.envyAlpha20}`};
  box-shadow: ${({ theme }) => `0px 0px 16px 0px ${theme.colors.envyAlpha20}`};

  @media (max-width: 500px) {
    width: 390px;
  }

  @media (max-width: 425px) {
    width: 100%;
  }
`;

const ChampionBanner = styled(Flex)`
  background-size: cover;
  height: 192px;
  width: 100%;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
`;

const Title = styled(Text)`
  @media (max-width: 425px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

const Subtitle = styled(Text)`
  @media (max-width: 425px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const StyledButton = styled(Button)<{ notified?: boolean }>`
  ${({ notified }) =>
    notified &&
    `
      animation: notifyPulse 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    `}
  @keyframes notifyPulse {
    0% {
      transform: scale(1);
    }
    60% {
      transform: scale(1.04);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const StyledNoThanks = styled(Flex)`
  color: ${({ theme }) => theme.colors.envy};
  cursor: pointer;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
